import React from 'react';
/**
 * Якорь, позволяющий подскролливать с учетом высоты шапки
 * или указанной высоты методом window.scrollIntoView
 * @param props ({ anchorId: string, scrollMarginTop?: number })
 */
export var Anchor = function Anchor(_ref) {
  var _document$querySelect;
  var anchorId = _ref.anchorId,
    scrollMarginTop = _ref.scrollMarginTop;
  var headerHeight = typeof document !== 'undefined' ? (_document$querySelect = document.querySelector('header')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight : 0;
  return /*#__PURE__*/React.createElement("span", {
    id: anchorId,
    style: {
      scrollMarginTop: scrollMarginTop || headerHeight
    },
    "data-t-id": "common-Anchor"
  });
};